module.exports = __webpack_public_path__ + "static/media/cloud.ce3c65dc.png";